import React from 'react';
import './Footer.css';
import footerImg from '../assets/网站设计/移动端切图/footer_img.webp';

interface FooterProps {
  isMobile: boolean;
}

const Footer: React.FC<FooterProps> = ({ isMobile }) => {
  if (!isMobile) return null; // Only show on mobile

  return (
    <footer className="footer">
      <div className="footer-content">
        <img
          src={footerImg}
          alt="Footer"
          className="footer-image"
        />
      </div>
    </footer>
  );
};

export default Footer;